import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function UserDetailsCard(props) {
	return (
		<div className="UserDetailsCard bg-white w-full min-w-96 mt-4 p-5 rounded-md shadow border text-gray-800">
			<div className="grid lg:grid-cols-12 lg:gap-5">
				<div className="col-span-12 lg:col-span-2">
					<h2 className="text-lg lg:text-xl font-semibold mb-2">
						User Profile
					</h2>
				</div>
				<div className="col-span-12 lg:col-span-10">
					<div className="border p-4 bg-gray-50 shadow-sm rounded-md">
						<span className="float-right hover:underline">
							<Link
								to="edit"
								state={{
									isEditing: true
								}}
							>
								Edit
							</Link>
						</span>
						<div className="grid md:grid-cols-12">
							<div className="md:col-span-6">
								<div className="font-semibold">First Name</div>
								<span className="my-1 mr-3">John</span>
								<div className="font-semibold mt-4">Last Name</div>
								<span className="mr-2 block">Smith</span>
							</div>
							<div className="md:col-span-6 mt-4 md:mt-0">
								<div className="font-semibold">Email (Username)</div>
								<span className="mr-2 block">js23@gmail.com</span>
								<div className="font-semibold mt-4">Password</div>
								<span className="mr-2 block">******</span>
								<div className="font-semibold mt-2">Accounts</div>
								<span className="mr-2 block">
									<Link to="/accounts/1" className="hover:underline">
										JS Maui Properties
									</Link>,{' '}
									<Link to="/accounts/1" className="hover:underline">
										JS Oahu Properties
									</Link>
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
